import * as api from '../api/microsoft';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_CONFERENCE_BY_ID = createRequestTypes(
  `${prefix}/FETCH_CONFERENCE_BY_ID`,
);

export const fetchConferenceByID = makeApiActionCreatorV3(
  api.fetchConferenceByID,
  FETCH_CONFERENCE_BY_ID[START],
  FETCH_CONFERENCE_BY_ID[SUCCESS],
  FETCH_CONFERENCE_BY_ID[ERROR],
);

export const FETCH_CONFERENCES = createRequestTypes(
  `${prefix}/FETCH_CONFERENCES`,
);

export const fetchConferences = makeApiActionCreatorV3(
  api.fetchConferences,
  FETCH_CONFERENCES[START],
  FETCH_CONFERENCES[SUCCESS],
  FETCH_CONFERENCES[ERROR],
);

export const CREATE_CONFERENCE = createRequestTypes(
  `${prefix}/CREATE_CONFERENCE`,
);

export const createConference = makeApiActionCreatorV3(
  api.createConference,
  CREATE_CONFERENCE[START],
  CREATE_CONFERENCE[SUCCESS],
  CREATE_CONFERENCE[ERROR],
);

export const FETCH_CONFERENCE_ATTENDANCE = createRequestTypes(
  `${prefix}/FETCH_CONFERENCE_ATTENDANCE`,
);

export const fetchConferenceAttendance = makeApiActionCreatorV3(
  api.fetchConferenceAttendance,
  FETCH_CONFERENCE_ATTENDANCE[START],
  FETCH_CONFERENCE_ATTENDANCE[SUCCESS],
  FETCH_CONFERENCE_ATTENDANCE[ERROR],
);

export const FETCH_CONFERENCE_RECORDING = createRequestTypes(
  `${prefix}/FETCH_CONFERENCE_RECORDING`,
);

export const fetchConferenceRecording = makeApiActionCreatorV3(
  api.fetchConferenceRecording,
  FETCH_CONFERENCE_RECORDING[START],
  FETCH_CONFERENCE_RECORDING[SUCCESS],
  FETCH_CONFERENCE_RECORDING[ERROR],
);

export const START_CONFERENCE = createRequestTypes(
  `${prefix}/START_CONFERENCE`,
);

export const startConference = makeApiActionCreatorV3(
  api.startConference,
  START_CONFERENCE[START],
  START_CONFERENCE[SUCCESS],
  START_CONFERENCE[ERROR],
);
